/* eslint-disable no-undef */
import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import MaterialTable from "material-table"
import { Button, makeStyles, TextField, Typography } from "@material-ui/core"
import Grid from '@mui/material/Grid';
import Modal from "@material-ui/core/Modal"
import Backdrop from "@material-ui/core/Backdrop"
import Fade from "@material-ui/core/Fade"
import tableIcons from "../../utils/helper"
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined"
import * as userGroupActions from "../../actions/userGroupActions"
import * as vehicleGroupActions from "../../actions/vehicleGroupActions"
import * as locationGroupActions from "../../actions/locationGroupActions"
import UserGroupSummary from "./userGroupSummary"
import { i18n } from "../i18n"
import { getLabel } from "../../utils/functions";

const MaterialTableDemo = () => {
  const _ = require("lodash")
  const classes = useStyles()
  const dispatch = useDispatch()
  // const settings = useSelector(state => state.userInfo.settings)
  const userType = useSelector(state => _.get(state, "userInfo.settings.user.userType", ""))
  const auth = useSelector(state => ({ ...state.auth }))
  const [selectedRow, setSelectedRow] = React.useState(null)
  const userGroups = useSelector(state => _.get(state, "userGroups.data", []))
  const isFetching = useSelector(state => _.get(state, "userGroups.isFetching", false))
  const locationGroups = useSelector(state => _.get(state, "locationGroups.data", []))
  const vehicleGroups = useSelector(state => _.get(state, "vehicleGroups.data", []))
  const itGroups = useSelector(state => _.get(state, "userInfo.settings.itCodeGroups", []))
  const [userGroupState, setUserGroupState] = React.useState([]);
  const [locationGroupState, setLocationGroupState] = React.useState([])
  const [vehicleGroupState, setVehicleGroupState] = React.useState([])
  const [pageLoad, setPageLoad] = React.useState(false)
  const [open, setOpen] = React.useState(false)
  const [newGroupName, setNewGroupName] = React.useState("")
  const [hiddenNameText, setHiddenNameText] = React.useState(true)
  const [duplicateRow, setDuplicateRow] = React.useState()

  function duplicateItGroup(rowData) {
    setDuplicateRow(rowData)
    setOpen(true)
  }

  function confirmDuplicate() {
    if (newGroupName) {
      setHiddenNameText(true)
      setOpen(false)
      const itCodeGroups = duplicateRow.itCodeGroups.map(e => e._id);
      const locationGroups = duplicateRow.locationGroups.map(e => e._id);
      const vehicleModelGroups = duplicateRow.vehicleModelGroups.map(e => e._id);
      const allowTotalSubtotal = _.get(duplicateRow.meta?.find(e => e.key === "allowTotalSubtotal"), "value", false)
      const meta = [{
        key: "allowTotalSubtotal",
        value: JSON.stringify(allowTotalSubtotal)
      }]
      const group = {
        name: newGroupName,
        active: duplicateRow.active,
        itCodeGroups,
        locationGroups,
        vehicleModelGroups,
        meta
      }
      
      dispatch(userGroupActions.createUserGroup({ token: auth.token }, group))
    } else {
      setHiddenNameText(false)
    }
  }

  function typeNewGroupName(name) {
    setNewGroupName(name)
  }

  useEffect(() => {
    if (pageLoad === false) {
      dispatch(userGroupActions.getUserGroups({ token: auth.token }))
      dispatch(vehicleGroupActions.getVehicleGroups({ token: auth.token }))
      dispatch(locationGroupActions.getLocationGroups({ token: auth.token }))
      setPageLoad(true)
      // setSelectedRow({
      //   tableData: { id: 0 }
      // })
    }
  }, [])

  useEffect(() => {
    if(!_.isEmpty(userGroups) || !_.isEmpty(locationGroups) || !_.isEmpty(vehicleGroups)) {
        setLocationGroupState(locationGroups);
        setVehicleGroupState(vehicleGroups)
        setUserGroupState(userGroups)
    }
  }, [userGroups, locationGroups, vehicleGroups])

  const handleClose = () => {
    setOpen(false)
  }

  return <i18n.Consumer>
    {context => (
      <React.Fragment>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <h2 id="transition-modal-title">Duplicate Group</h2>
              <TextField
                id="dayExtend"
                name="dayExtend"
                label="Group Name"
                margin="dense"
                variant="outlined"
                value={newGroupName}
                onChange={e => typeNewGroupName(e.target.value)}
                type="text"
                fullWidth
              ></TextField>
              <Typography id="requiredNameText" style={{ fontSize: 13, marginLeft: 2, color: "red" }} hidden={hiddenNameText}>
                * Name is required
              </Typography>
              <Grid container alignItems="center" justifyContent="center" style={{ marginTop: 20 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClose}
                  style={{
                    minWidth: 100,
                    margin: 5
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={confirmDuplicate}
                  style={{
                    minWidth: 100,
                    margin: 5
                  }}
                //onClick={confirmExtension}
                >
                  Confirm
                </Button>
              </Grid>
            </div>
          </Fade>
        </Modal>
        <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
          <Grid item xs={5} lg={5}>
            <MaterialTable
              icons={tableIcons}
              isLoading={isFetching}
              title={getLabel(context, "userGroups.header", "User Groups", i18n)}
              columns={[
                { title: getLabel(context, "userGroups.userGroup", "User Group", i18n), field: "name" }
                // { title: "active", field: "active" }
                // { title: "ID", field: "id", hidden: "true" }
                /* { title: 'Allowed', field: 'allowed' , type: 'boolean'}, */
              ]}
              options={{
                minBodyHeight: "calc(100vh - 224px)",
                maxBodyHeight: "calc(100vh - 224px)",
                pageSize: 20,
                rowStyle: rowData => ({
                  backgroundColor: selectedRow && selectedRow.tableData.id === rowData.tableData.id ? "#EEE" : "#FFF",
                  color: userGroupState && rowData && rowData.active ? "black" : "lightgrey"
                })
              }}
              data={userGroupState ? userGroupState.map(x => Object.assign({}, x)) : []}
              onRowClick={(event, selectedRow) => {
                setSelectedRow(selectedRow)
              }}
              editable={{
                isAddable: () => userType == "ADMIN" || userType == "SERVICE_MANAGER",
                isDeletable: () => userType == "ADMIN" || userType == "SERVICE_MANAGER",
                isEditable: rowData => (rowData.active == true && userType == "ADMIN") || (rowData.active == true && userType == "SERVICE_MANAGER"),
                onRowAdd: newData =>
                  new Promise(resolve => {
                    setTimeout(() => {
                      {
                        const group = {
                          name: newData.name,
                          locationGroups: [],
                          itCodeGroups: [],
                          vehicleModelGroups: [],
                          meta: [
                            {
                              key: "allowTotalSubtotal",
                              value: "false"
                            }
                          ]
                        }
                        dispatch(userGroupActions.createUserGroup({ token: auth.token }, group))
                      }
                      resolve()
                    }, 1000)
                  }),
                // onRowUpdate: newData =>
                //   new Promise(resolve => {
                //     setTimeout(() => {
                //       {
                //         let itGroup = newData
                //         dispatch(
                //           userInfoActions.setItGroup(
                //             { token: auth.token },
                //             itGroup
                //           )
                //         )
                //       }
                //       resolve()
                //     }, 1000)
                //   }),
                onRowDelete: oldData =>
                  new Promise(resolve => {
                    setTimeout(() => {
                      {
                        setSelectedRow(null)
                        dispatch(userGroupActions.deleteUserGroup({ token: auth.token }, oldData))
                      }
                      resolve()
                    }, 1000)
                  })
              }}
              actions={[
                {
                  // eslint-disable-next-line react/display-name
                  icon: () => <FileCopyOutlinedIcon />,
                  tooltip: "Duplicate",
                  onClick: (event, rowData) => {
                    duplicateItGroup(rowData)
                  }
                }
              ]}
            />
          </Grid>
          {selectedRow && <UserGroupSummary
            selectedRow={selectedRow}
            vehicleGroups={vehicleGroupState}
            locationGroups={locationGroupState}
            itGroups={structuredClone(itGroups)}
            userGroupState={userGroupState}
            setSelectedRow={setSelectedRow}
            auth={auth}
            isLoading={isFetching}
          />}
        </Grid>
      </React.Fragment>
    )}
  </i18n.Consumer>
}

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles(theme => ({
  root: {
    "& button.MuiButtonBase-root": {
      padding: "5px"
    }
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  modalTextField: {
    width: 80,
    marginTop: 0,
    marginLeft: 10,
    padding: 0
  },
  textField: {
    "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      display: "none"
    },
    "& .MuiInputBase-input": {
      textAlign: "center"
    },
    maxWidth: 300
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    "&:focus": {
      outlineColor: "transparent"
    },
    borderRadius: 3,
    minHeight: 175,
    minWidth: 500
  },
  noFocus: {
    "&:focus": {
      outlineColor: "transparent"
    }
  }
}))

export default MaterialTableDemo
